import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-drop-fill text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  鲍鱼盒子
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-6">
                专注高端鲍鱼礼盒定制，精选全球优质鲍鱼，以匠心工艺打造尊贵礼品体验。让每一份心意都显得尊贵非凡。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-red-packet-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">快速导航</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/categories" className="text-sm text-background-400 hover:text-primary-400 transition-colors">产品分类</Link></li>
                <li><Link to="/articles" className="text-sm text-background-400 hover:text-primary-400 transition-colors">鲍鱼百科</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">产品分类</h4>
              <ul className="space-y-3">
                <li><Link to="/categories?tab=business" className="text-sm text-background-400 hover:text-primary-400 transition-colors">商务送礼</Link></li>
                <li><Link to="/categories?tab=festival" className="text-sm text-background-400 hover:text-primary-400 transition-colors">节日礼盒</Link></li>
                <li><Link to="/categories?tab=family" className="text-sm text-background-400 hover:text-primary-400 transition-colors">家庭享用</Link></li>
                <li><Link to="/articles" className="text-sm text-background-400 hover:text-primary-400 transition-colors">选购指南</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  <span className="text-sm text-background-400">400-888-9999</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  <span className="text-sm text-background-400">service@baoyuhezi.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <span className="text-sm text-background-400">上海市浦东新区陆家嘴金融贸易区世纪大道100号</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-400">
                    <i className="ri-time-line text-sm"></i>
                  </div>
                  <span className="text-sm text-background-400">周一至周日 9:00 - 21:00</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 鲍鱼盒子 版权所有 | <a href="#" className="hover:text-primary-400 transition-colors">沪ICP备2024XXXXXXXX号</a>
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors">退换政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}